/* istanbul ignore next */
// No-op is supposed to be an empty function, with unused var, and accepts any type.
// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export function noop(...args: any[]): void {}
